import { CollaboratorListContainer } from "./__styles__/CollaboratorList";
import { CollaboratorRow } from "./CollaboratorRow";
import { Collaborator, PermissionOption, RoleOption } from "./types";

interface CollaboratorListProps {
  collaborators: Collaborator[];
  permissionOptions: PermissionOption[];
  onPermissionChange: (collaboratorId: string, permission: string) => void;
  onRemove: (collaboratorId: string) => void;
  showPermissionOptions?: boolean;
  roleOptions?: RoleOption[];
  onRoleChange?: (
    collaboratorId: string,
    role: string,
    userGroupId: string,
  ) => void;
}

export const CollaboratorList = ({
  collaborators,
  permissionOptions,
  onPermissionChange,
  onRemove,
  showPermissionOptions = true,
  roleOptions,
  onRoleChange,
}: CollaboratorListProps) => {
  return (
    <CollaboratorListContainer>
      {collaborators.map(collaborator => (
        <CollaboratorRow
          key={collaborator.id}
          collaborator={collaborator}
          permissionOptions={permissionOptions}
          onPermissionChange={onPermissionChange}
          onRemove={onRemove}
          showPermissionOptions={showPermissionOptions}
          roleOptions={roleOptions}
          onRoleChange={onRoleChange}
        />
      ))}
    </CollaboratorListContainer>
  );
};
